import cloneDeep from 'lodash/cloneDeep'
import { and, email, helpers, required, requiredUnless } from '@vuelidate/validators'

// these APIs are auto-imported from @vueuse/core
export const clone = cloneDeep
export const requiredWith = (msg: string) => helpers.withMessage(msg, required)
export const emailWith = (msg: string) => helpers.withMessage(msg, email)
export const requiredUnlessWith = (msg: string, asyncFunction: () => boolean) => helpers.withMessage(msg, requiredUnless(asyncFunction))

export function isDateAfter(msg: string, obj: any, dateKey: string) {
  return helpers.withMessage(
    msg,
    and(required, (value) => {
      const fromDate: string = obj[dateKey]

      if (!value || !fromDate)
        return true
      const valueAsDate = Date.parse(value)
      const fromDateAsDate = Date.parse(fromDate)
      return valueAsDate > fromDateAsDate
    }),
  )
}

export function isDateAfterString(msg: string, date: string) {
  return helpers.withMessage(
    msg,
    and(required, (value) => {
      const fromDate: string = date

      if (!value || !fromDate)
        return true
      const valueAsDate = Date.parse(value)
      const fromDateAsDate = Date.parse(fromDate)
      return valueAsDate >= fromDateAsDate
    }),
  )
}
